import { useEffect } from 'react';

interface ExternalRedirectProps {
  to: string;
  /** Optional: preserve current URL params when redirecting */
  preserveParams?: boolean;
}

/**
 * Component that redirects to an external URL (outside React Router).
 * Used for redirecting unauthenticated users to WordPress marketing site.
 *
 * @example
 * // Redirect to WordPress homepage
 * <ExternalRedirect to="https://pedagogue.io" />
 *
 * // Redirect preserving partner_id and other params
 * <ExternalRedirect to="https://pedagogue.io/pricing" preserveParams />
 */
export const ExternalRedirect: React.FC<ExternalRedirectProps> = ({
  to,
  preserveParams = false,
}) => {
  useEffect(() => {
    let targetUrl = to;

    if (preserveParams) {
      const currentParams = window.location.search;
      if (currentParams) {
        const separator = to.includes('?') ? '&' : '?';
        targetUrl = `${to}${separator}${currentParams.slice(1)}`;
      }
    }

    window.location.href = targetUrl;
  }, [to, preserveParams]);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting...</p>
      </div>
    </div>
  );
};

export default ExternalRedirect;
